<!-- As a heading -->
<div class="footerBox">
  <footer>
    <div class="container">
      <div class="footer-container">
        <div class="footer-content">
          <img
            *ngIf="appName"
            src="./assets/images/ezyestLogo.svg"
            class="mb-2"
            alt="logo footer"
          />
          <h3>
            <span>Company</span>
            <ul>
              <li>Home</li>
              <li>New Launches</li>
              <li>Insights</li>
              <li>About Us</li>
            </ul>
          </h3>
          <h4>
            <span>Contact Us</span>
            <ul>
              <li><i class="bi bi-telephone"></i> +91 8064526920</li>
              <li>info&#64;ezyest.com</li>
            </ul>
          </h4>
          <!-- <h6>All right reserved &copy; 2024</h6> -->
        </div>
        <div class="footer-logo">
          <h3>Get the {{ appName }} app on</h3>

          <div class="row g-2 align-items-center">
            <div class="col-auto col-sm-4">
              <img
                class="img-fluid border-0 appQRcodeFut"
                src="/assets/images/EzyestAppDownloadQR.png"
                alt="APP Download QR Code"
              />
            </div>

            <div class="col-auto col-sm-8">
              <p>
                <a
                  href="https://play.google.com/store/apps/details?id=com.arcis.ezyest"
                  target="_blank"
                  ><img src="/assets/images/google-play.png" alt="Logo"
                /></a>
              </p>
              <p>
                <a
                  href="https://apps.apple.com/in/app/ezyest/id6743520081"
                  target="_blank"
                  ><img src="/assets/images/app-store.png" alt="Logo"
                /></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fixedFooter">
      <div class="container">
        <div class="fixedMain">
          <div class="left">
            <!-- <p>All right reserved © 2024</p> -->
            <p>&nbsp;</p>
          </div>
          <div class="right">
            <button
              type="button"
              class="footerAction"
              [isOpen]="isPopOverOpen"
              (click)="onPopOverClick()"
              [popover]="popTemplate"
              [popoverTitle]="title"
              triggers=""
              [outsideClick]="true"
            >
              <i class="bi bi-info-square"></i>
            </button>
            <ng-template #popTemplate>
              <div class="versionBox">
                <svg
                  class="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    class="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    class="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <span
                  >(Version: <strong>{{ jsonData?.appVersion }}</strong
                  >)</span
                >
              </div>
            </ng-template>
            <div class="envirement mr-2">
              {{ jsonData?.env }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
